import type { paths } from '../../types/clients/payments'
import { computed, useApi, useCoreConfig, useOpenapi, useQuery, useUserInfo } from '#imports'
import type { UseQueryOverrideOptions } from '../../types'

/**
 * @title usePaymentsClient
 * @see Docs https://payments-prod.spilnu.dk/api/documentation
 */
export const usePaymentsClient = () => {
    const { site: { brand } } = useCoreConfig()
    const client = useOpenapi<paths>({
        baseUrl: '/gateway/payments',
        service: 'payments'
    })

    function useGetDepositSuccessfulCount(options: UseQueryOverrideOptions = {}) {
        // TODO: Fix when openapi spec works again in payments service, so we get a properly typed client
        const api = useApi({
            baseURL: '/gateway/payments',
            service: 'payments'
        })
        const { isLoggedIn } = useUserInfo()

        const query = useQuery(() => {
            return api<{
                /**
                 * Number of successful deposists a user has made.
                 * Zero equals no deposits made.
                 */
                count: number
            }>('/api/public/cashier/deposit/successful-count', {
                query: {
                    brand
                }
            })
        }, {
            server: false,
            lazy: true,
            ...options,
            key: 'payments:cashier:deposit:successful-count',
            enabled: isLoggedIn
        })

        const isFirstDeposit = computed(() => {
            return query.data.value?.count === 0
        })

        return query.enrich({
            isFirstDeposit
        })
    }

    return {
        client,
        useGetDepositSuccessfulCount
    }
}
